import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const applyPromoService = serviceBase({
	request: (data) => axiosClient.post('promo/apply-promo', {cartData: data}),
});

export default applyPromoService;  